<template>
  <div class="k-page padding-50">
    <Card :bordered="false">
      <Input v-model="searchText" placeholder="Search RFP number..." style="width: 300px" class="k-input"/>
      <TechRfpList :searchText="searchText"/>
    </Card>
  </div>
</template>

<script>
import TechRfpList from '@/components/rfp-list/tech-provider/TechRfpList'

export default {
  components: {
    TechRfpList
  },

  data () {
    return {
      searchText: null
    }
  }
}
</script>
